export function isNotNullOrUndefined(object: any): boolean {
  return object !== undefined && object !== null;
}
